import { request } from '../request';

export type JourneyNotificationType = 'error' | 'completion';

export type JourneyNotification = {
  subscribed: boolean;
  type: JourneyNotificationType;
};

export const loadJourneyNotification = async (
  journeyShortId: string,
  type: JourneyNotificationType
) => {
  const response = await request.get<JourneyNotification>(
    `v1/journeys/${journeyShortId}/notifications/${type}/`
  );
  return response.data;
};

export const subscribeJourneyNotification = async ({
  journeyShortId,
  type,
}: {
  journeyShortId: string;
  type: JourneyNotificationType;
}) => {
  const response = await request.post<JourneyNotification>(
    `v1/journeys/${journeyShortId}/notifications/${type}/`
  );
  return response.data;
};

export const unsubscribeJourneyNotification = async ({
  journeyShortId,
  type,
}: {
  journeyShortId: string;
  type: JourneyNotificationType;
}) => {
  await request.delete(`v1/journeys/${journeyShortId}/notifications/${type}/`);
};
